import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import ColorPickerDialog from '../../../../../../../../shared/components/color-picker/color-picker.dialog';
import useDebouncedValue from '../../../../../../../../shared/services/useDebounce.hook';


/**
 * @author Pradeep R <pradeep.rajendran@rldatix.com>
 * @createdOn Jan/21/2025
 */
export default function StyleColorPickerComponent(
    { color, onChange }
        : {
            color?: string | null;
            onChange: (newColor: string) => void
        }
) {
    const [newValue, setNewValue] = useDebouncedValue<string>('transparent', 0); // Using the custom hook

    useEffect(() => {
        onChange(newValue)
    }, [newValue])

    return (<Grid item container direction='row' sx={{ border: '0px solid orange' }} justifyContent={'center'}>

        <ColorPickerDialog onChange={(value) => setNewValue(value)}
            color={color?.startsWith('#') ? color : 'transparent'}
        />

    </Grid>)
}